import React from 'react';

// ============================================================
// About page — copy from docs/about.txt
// ============================================================

export function AboutPage({ onNavigate }) {
  return (
    <div className="static-page">
      {/* Intro band */}
      <section className="about-intro about-intro--network">
        <div className="about-intro-inner">
          <div className="about-intro-text">
            <div className="static-eyebrow">About</div>
            <h1 className="static-title">Introducing the<br />New Economy Index</h1>
            <p className="static-lede">
              Across Europe, a growing ecosystem of organisations is rethinking
              the very foundations of our economic system. This index aims to make
              the field more visible, and help organisations find one another, connect, and
              strengthen their collective impact.
            </p>
            <div className="about-beta-note">
              <strong>We're building in the open.</strong> Take a look around, add or
              update your organisation, or drop us some feedback.
            </div>
            <div className="hero-actions" style={{ marginTop: 20 }}>
              <a className="btn-primary btn-sm" href="#/submit" onClick={(e) => {e.preventDefault();onNavigate('submit');}}>＋ Add your organisation</a>
              <a className="btn-secondary" href="#/?view=wheels" onClick={(e) => {e.preventDefault();onNavigate('directory', { view: 'wheels' });}} style={{ padding: '7px 14px', fontSize: 12 }}>Open the directory →</a>
              <a className="btn-secondary" href="https://docs.google.com/forms/d/e/1FAIpQLSfJaAxveZCS9AxsB_Oeo10iEZCj9U0TsUXQikhbHAGk6wI5Ow/viewform" target="_blank" rel="noopener noreferrer" style={{ padding: '7px 14px', fontSize: 12 }}>Offer feedback</a>
            </div>
          </div>
        </div>
        <img className="about-intro-accent" src="/assets/europe-network.svg" alt="" aria-hidden="true" />
      </section>

      {/* What is it */}
      <section className="static-section cols-2">
        <div>
          <div className="static-eyebrow">What is it?</div>
          <h2 className="static-h2">An open atlas of economic systems-change organisations.</h2>
        </div>
        <div>
          <p>
            Our current economic system drives inequality, ecological breakdown
            and social instability. Across Europe, a diverse community of
            organisations are rethinking the foundations of the economy to align
            it with human wellbeing within the limits of a living planet.
          </p>
          <p>
            This index is an open-access, filterable directory showcasing
            <strong> 800+ organisations across 35 European countries</strong> working
            toward economic systems change. It aims to support practitioners,
            funders, and other allies to discover, collaborate and align across
            the field.
          </p>
        </div>
      </section>

      {/* Background band */}
      <section className="about-band">
        <div className="static-band-inner fertile-band-inner">
         <div className="fertile-band-text">
          <div className="static-eyebrow dark">Background</div>
          <h2 className="static-h2 static-h2-lg about-band-h">Fertile Ground — the research behind the Index</h2>
          <p className="static-lede-dark">
            The Index builds on a comprehensive mapping commissioned by
            <strong> Partners for a New Economy</strong> and carried out by
            <strong> Metabolic</strong> in 2025.
          </p>
          <div className="fertile-list">
            <div className="fertile-item">
              <div className="fertile-icon" aria-hidden="true">
                {/* Taxonomy / grid */}
                <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="5" width="9" height="9" rx="1.5" /><rect x="18" y="5" width="9" height="9" rx="1.5" /><rect x="5" y="18" width="9" height="9" rx="1.5" /><rect x="18" y="18" width="9" height="9" rx="1.5" /></svg>
              </div>
              <div className="fertile-body">
                <div className="fertile-n">01</div>
                <div className="fertile-text">A categorisation of activities and themes across the field.</div>
              </div>
            </div>
            <div className="fertile-item">
              <div className="fertile-icon" aria-hidden="true">
                {/* Insight / magnifier over chart */}
                <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 26l6-7 4 4 6-9 6 6" /><circle cx="21" cy="12" r="5" /><path d="M25 16l3 3" /></svg>
              </div>
              <div className="fertile-body">
                <div className="fertile-n">02</div>
                <div className="fertile-text">Insights into the field's strengths, gaps, and emerging dynamics.</div>
              </div>
            </div>
            <div className="fertile-item">
              <div className="fertile-icon" aria-hidden="true">
                {/* Compass / direction */}
                <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="16" cy="16" r="11" /><path d="M20 12l-2 6-6 2 2-6z" /></svg>
              </div>
              <div className="fertile-body">
                <div className="fertile-n">03</div>
                <div className="fertile-text">Recommendations for funders, practitioners, and ecosystem builders.</div>
              </div>
            </div>
          </div>
          <a className="about-band-cta" href="https://www.metabolic.nl/publications/fertile-ground/" target="_blank" rel="noopener noreferrer">Read the full report →</a>
         </div>
         <a className="fertile-band-cover" href="https://www.metabolic.nl/publications/fertile-ground/" target="_blank" rel="noopener noreferrer" aria-label="Fertile Ground report — open publication">
           <img src="/assets/fertile-ground-cover.png" alt="Fertile Ground report cover" />
         </a>
        </div>
      </section>

      {/* What can you do */}
      <section className="static-section">
        <div className="static-col-full">
          <div className="static-eyebrow">What can you do with it?</div>
          <h2 className="static-h2 static-h2-lg">Three ways to engage.</h2>
          <div className="about-trio">
            <div className="about-trio-card">
              <div className="about-trio-icon">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="6" /><path d="M20 20l-4-4" /></svg>
              </div>
              <h3>Explore the field</h3>
              <p>Search and filter organisations by country, activity, theme, and more.</p>
              <a href="#/" onClick={(e) => {e.preventDefault();onNavigate('directory');}} className="inline-link">Open directory →</a>
            </div>
            <div className="about-trio-card">
              <div className="about-trio-icon">
                {/* Two people */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="9" r="2.3" /><path d="M15 15c3 0 6 2 6 5" /></svg>
              </div>
              <h3>Connect &amp; collaborate</h3>
              <p>Find like-minded partners and initiatives across Europe.</p>
            </div>
            <div className="about-trio-card">
              <div className="about-trio-icon">
                {/* Person adding to a group — person with plus */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="10" cy="8" r="3" /><path d="M4 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><path d="M19 7v6M16 10h6" /></svg>
              </div>
              <h3>Join the community</h3>
              <p>Add your organisation to the index and make your work visible.</p>
              <a href="#/submit" onClick={(e) => {e.preventDefault();onNavigate('submit');}} className="inline-link">Add your organisation →</a>
            </div>
          </div>

          {/* Newsletter bar */}
          <div className="about-newsletter">
            <div className="about-newsletter-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
            </div>
            <div className="about-newsletter-text">
              <strong>Get monthly new economy updates from around the world.</strong>
              <span>Subscribe to Partners for a New Economy's Roundup newsletter.</span>
            </div>
            <a className="btn-primary about-newsletter-cta" href="https://p4ne.us8.list-manage.com/subscribe?u=a8a2292c0131db6c6b0bdce16&id=71d99c985d" target="_blank" rel="noopener noreferrer">
              Subscribe to the Roundup →
            </a>
          </div>
        </div>
      </section>

      {/* Inclusion criteria */}
      <section className="static-section">
        <div className="static-col-full">
          <div className="static-eyebrow">Inclusion criteria</div>
          <h2 className="static-h2 static-h2-lg">Who qualifies an organisation for the Index?</h2>
          <p style={{ maxWidth: 720 }}>
            Organisations already included, or those wishing to be added, must
            meet <strong>all four</strong> of the following criteria. All submissions are
            reviewed before publication, so updates may take some time.
          </p>
          <div className="criteria-grid">
            <CriteriaCard n="01" title="Not-for-profit"
            ok="Nonprofits (NGOs, foundations, associations, charities) and not-for-profits (cooperatives, social enterprises) reinvesting surpluses into their mission."
            out="For-profits, EU & other short-term projects." />
            <CriteriaCard n="02" title="Based in Europe"
            ok="Must be based in, or maintain a legal entity / office in, a European country."
            out="Groups based in Europe but working primarily outside Europe, or those without a European presence." />
            <CriteriaCard n="03" title="Mission-aligned"
            ok="Organisations working explicitly or implicitly on transforming our economic system — economy-wide or sector-specific (energy, housing, agriculture) when linked to systemic change."
            out="Organisations working on a social or environmental issue without a connection to changing the economic system." />
            <CriteriaCard n="04" title="Legally incorporated"
            ok="Your organisation should be formally incorporated and have a website."
            out="Temporary initiatives, EU projects." />
          </div>
        </div>
      </section>

      {/* What is the new economy */}
      <section className="about-neweco">
        <div className="static-band-inner">
          <div className="static-eyebrow dark">What is the &ldquo;new economy&rdquo;?</div>
          <h2 className="static-h2 static-h2-lg about-band-h">
            An umbrella term for an economy designed for wellbeing and justice, rooted in and respectful of the living planet.
          </h2>
          <p className="static-lede-dark">
            The term &ldquo;new economy&rdquo; is intentionally broad. It includes many
            movements and schools of thought. It is less about choosing one, and
            more about recognising a shared intent — a big tent of efforts that
            share the following objectives:
          </p>
          <div className="objectives-grid">
            <div className="objective-card">
              <div className="objective-mark" aria-hidden="true">
                {/* Leaf — ecological */}
                <svg viewBox="0 0 32 32"><path d="M6 26c0-10 8-18 20-18 0 12-8 20-20 20z" /><path d="M6 26l10-10" /></svg>
              </div>
              <h4>Ecological sustainability</h4>
              <p>Living within planetary boundaries, restoring ecosystems, and recognising the economy as embedded in the natural systems that sustain life.</p>
            </div>
            <div className="objective-card">
              <div className="objective-mark" aria-hidden="true">
                {/* Balance scale — justice */}
                <svg viewBox="0 0 32 32"><path d="M16 6v20" /><path d="M10 26h12" /><path d="M7 10h18" /><path d="M7 10l-4 8a4 4 0 008 0zM25 10l-4 8a4 4 0 008 0z" /></svg>
              </div>
              <h4>Social justice &amp; equity</h4>
              <p>Fair wealth distribution and dismantling systemic inequalities.</p>
            </div>
            <div className="objective-card">
              <div className="objective-mark" aria-hidden="true">
                {/* Circle of people — participation */}
                <svg viewBox="0 0 32 32"><circle cx="16" cy="7" r="3" /><circle cx="7" cy="20" r="3" /><circle cx="25" cy="20" r="3" /><circle cx="16" cy="27" r="3" /><path d="M13 9l-4 9M19 9l4 9M9 23l5 3M23 23l-5 3" /></svg>
              </div>
              <h4>Participatory governance</h4>
              <p>Community participation, shared ownership, self-determination, commons and mutual aid.</p>
            </div>
            <div className="objective-card">
              <div className="objective-mark" aria-hidden="true">
                {/* Heart — wellbeing */}
                <svg viewBox="0 0 32 32"><path d="M16 27s-9-5.5-9-13a5 5 0 019-3 5 5 0 019 3c0 7.5-9 13-9 13z" /></svg>
              </div>
              <h4>Wellbeing &amp; quality of life</h4>
              <p>Prioritising health, fulfilment and dignity rather than economic output alone.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="about-faq-section">
        <div className="about-faq-inner">
          <div className="about-faq-head">
            <div className="static-eyebrow">FAQ</div>
            <h2 className="static-h2 static-h2-lg">Frequently asked questions</h2>
            <p className="about-faq-sub">
              Can't find an answer? <a href="mailto:NEindexEU@metabolic.nl">Send us an email</a> and we'll come back to you.
            </p>
          </div>
          <div className="about-faq-list">
            <FaqItem q="What is the New Economy Index?">
              <p>A directory of organisations based in Europe working to transform the economic system.</p>
            </FaqItem>
            <FaqItem q="Who stands behind the index?">
              <p>The New Economy Index was created by Metabolic and commissioned by Partners for a New Economy as a resource by the field, for the field – freely available to anyone. It is a non-profit initiative, devoid of external sponsorship or commercial interests that shape its development.</p>
            </FaqItem>
            <FaqItem q="Is the directory free to use?">
              <p>Yes — free and open to all.</p>
            </FaqItem>
            <FaqItem q="Why is my organisation already listed?">
              <p>The study <em>Fertile Ground</em> (2025) mapped 735 organisations working toward transforming our economy. We included basic information about each (name, website, country, mission) so the directory had some initial depth at launch.</p>
            </FaqItem>
            <FaqItem q="Should I update my organisation's entry?">
              <p>Yes, please. Only basic information is currently listed. To make the directory useful, we ask each organisation to re-submit key details — particularly their activities and themes — so it's easier for users to navigate the field.</p>
            </FaqItem>
            <FaqItem q="Can I add my organisation?">
              <p>Yes. Click <strong>“Add / update your org”</strong> at the top right and submit your details. Submissions are reviewed before publication, so it may take a little time. We strive to be inclusive, but organisations must meet our <a href="#inclusion" onClick={(e) => {e.preventDefault();const el = document.querySelector('.criteria-grid');if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });}}>inclusion criteria</a>.</p>
            </FaqItem>
            <FaqItem q="I'd like to remove my organisation. How?">
              <p>You can remove it at any time — email <a href="mailto:NEindexEU@metabolic.nl">NEindex@metabolic.nl</a> from an address tied to your organisation's domain so we can verify you represent it.</p>
            </FaqItem>
            <FaqItem q="I'm a funder interested in contributing to the new economy movement. Where do I start?">
              <p>Wonderful. The best next step is to reach out to <strong>Partners for a New Economy</strong> for a first conversation — <a href="mailto:info@p4ne.org">info@p4ne.org</a>.</p>
            </FaqItem>
          </div>
        </div>
      </section>
    </div>);

}

export function FaqItem({ q, children }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-q" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span className="faq-q-text">{q}</span>
        <span className="faq-q-icon" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="14" height="14">
            <path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      {open && <div className="faq-a"><div className="faq-a-inner">{children}</div></div>}
    </div>);

}

export function CriteriaCard({ n, title, ok, out }) {
  return (
    <div className="criteria-card">
      <div className="criteria-head">
        <div className="criteria-n">{n}</div>
        <h3 className="criteria-title">{title}</h3>
      </div>
      <p className="criteria-ok">{ok}</p>
      <div className="criteria-out">
        <span className="criteria-out-label">Excluded</span>
        <span>{out}</span>
      </div>
    </div>);

}
